/**
 * MONITORING TOOLS
 * Initialization of monitoring tools with configurations:
 * 1- Sentry
 * 2- NewRelic
 */
import * as Sentry from '@sentry/react';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { isReactPage } from 'utils/isReactPage';

(function () {
  /**
   * 1- Sentry
   */
  if (import.meta.env.REACT_APP_PRODUCTION === 'true' && isReactPage()) {
    Sentry.init({
      dsn: import.meta.env.REACT_APP_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
        }),
      ],
      release: import.meta.env.REACT_APP_SENTRY_RELEASE || '1',
      environment: import.meta.env.REACT_APP_ENVIRONMENT,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 0.5,
    });
  }

  /**
   * 2- NewRelic
   * IMPORTANT: Disabling in PROD environment for now until we have everything set up correctly.
   */
  if (import.meta.env.REACT_APP_PRODUCTION !== 'true' && import.meta.env.PROD && isReactPage()) {
    new BrowserAgent({
      info: {
        applicationID: import.meta.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
        licenseKey: import.meta.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
      },
    });
  }
})();
